export default __webpack_public_path__ + "static/media/arrowLeft.426c3f87.svg";